import { createFileRoute } from '@tanstack/react-router';

import { useSEO, useBreadcrumbSchema, PageSEO } from '../lib/seo';
import { LegalDocPage } from '../components/legal/LegalDocPage';
import { DocWarning } from '../components/legal/DocWarning';
// Body extracted verbatim from sites/www/public/legal/platform-eula/index.html (see privacy.tsx note).
import platformEulaBody from '../content/legal/platform-eula.body.html?raw';

export const Route = createFileRoute('/legal/platform-eula')({
  component: PlatformEulaPage,
});

function PlatformEulaPage() {
  useSEO(PageSEO.platformEula);
  useBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Trust', url: '/trust' },
    { name: 'Platform EULA', url: '/legal/platform-eula' },
  ]);

  return (
    <LegalDocPage
      title="Neumind Platform End-User Licence Agreement"
      breadcrumbLabel="Platform EULA"
      metaLine="Last updated 21 April 2026"
      subtitle="For Professional Users — clinicians, therapists, and rehabilitation professionals using the Neumind Platform."
      warning={
        <DocWarning summary="Please read these terms carefully">
          <p>
            By clicking “I Accept” or using the Neumind Platform (the “Platform”), you agree to be
            bound by this End-User Licence Agreement (“EULA”). If you do not agree, you must not use
            the Platform.
          </p>
        </DocWarning>
      }
    >
      <div dangerouslySetInnerHTML={{ __html: platformEulaBody }} />
    </LegalDocPage>
  );
}
